import React from "react";
import { Form, FormControl, Button } from "react-bootstrap";

const SearchBar = ({ onSearch }) => {
  return (
    <Form className="d-flex mb-3">
      <FormControl
        type="search"
        placeholder="Search reports"
        className="me-2"
        onChange={(e) => onSearch(e.target.value)}
      />
      <Button variant="primary">Search</Button>
    </Form>
  );
};

export default SearchBar;
